import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'react-loadable';
import Loader from '../Loader';
import { IconSensorTypeId } from '../../types/Icon';
const Loading = ({ size }) => _jsx(Loader, { size: size }, void 0);
const IconAmbientSensor = Loadable({
    loader: () => import('../../icons/SensorType/AmbientSensor'),
    loading: Loading,
});
const IconDoorSensor = Loadable({
    loader: () => import('../../icons/SensorType/DoorSensor'),
    loading: Loading,
});
const IconTemperatureSensor = Loadable({
    loader: () => import('../../icons/SensorType/TemperatureSensor'),
    loading: Loading,
});
const IconHumiditySensor = Loadable({
    loader: () => import('../../icons/SensorType/HumiditySensor'),
    loading: Loading,
});
const IconEnergySensor = Loadable({
    loader: () => import('../../icons/SensorType/EnergySensor'),
    loading: Loading,
});
const IconSensorTypeFactory = ({ classes, size, id, parameters }) => {
    switch (id) {
        case IconSensorTypeId.BINARY:
            return (_jsx(IconDoorSensor, { classes: classes, size: size, parameters: parameters }, void 0));
        case IconSensorTypeId.AMBIENT:
            return (_jsx(IconAmbientSensor, { classes: classes, size: size, parameters: parameters }, void 0));
        case IconSensorTypeId.TEMPERATURE:
            return (_jsx(IconTemperatureSensor, { classes: classes, size: size, parameters: parameters }, void 0));
        case IconSensorTypeId.HUMIDITY:
            return (_jsx(IconHumiditySensor, { classes: classes, size: size, parameters: parameters }, void 0));
        case IconSensorTypeId.ENERGY:
            return (_jsx(IconEnergySensor, { classes: classes, size: size, parameters: parameters }, void 0));
        default:
            return null;
    }
};
export default IconSensorTypeFactory;
